var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "reportModal",
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", {}, [
                _c("i", { staticClass: "feather icon-briefcase" }),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__("report.report_details")) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm.report !== null
                  ? [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.__("report.reported_by")) +
                            ": " +
                            _vm._s(_vm.report.user.full_name)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.__("report.reported_date")) +
                            ": " +
                            _vm._s(_vm.timeFormat(_vm.report.updated_at))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.__("report.comment_by")) +
                            " " +
                            _vm._s(_vm.report.user.first_name) +
                            ": " +
                            _vm._s(_vm.report.comment)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.__("report.reported_content")) + ":"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "newsfeedCard",
                          class: "card border-light " + _vm.class_body,
                          staticStyle: { "pointer-events": "none" },
                        },
                        [
                          _vm.report.module !== null &&
                          _vm.report.module.owner !== null
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "border-bottom pr-05" },
                                  [
                                    _c("newsfeed-owner-info", {
                                      attrs: {
                                        user_data: _vm.report.module.owner,
                                        profile_data: null,
                                        supplier_data: null,
                                        shared: false,
                                        time: _vm.report.module.created_at
                                          ? _vm.report.module.created_at
                                          : _vm.report.module.updated_at,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.report.reportable_type ===
                                "App\\Models\\Post"
                                  ? _c(
                                      "div",
                                      [
                                        _c("newsfeed-shared-post", {
                                          attrs: { data: _vm.report.module },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Resource"
                                  ? _c(
                                      "div",
                                      [
                                        _c("newsfeed-shared-resource", {
                                          attrs: { data: _vm.report.module },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Product"
                                  ? _c(
                                      "div",
                                      [
                                        _c("newsfeed-shared-product", {
                                          attrs: { data: _vm.report.module },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Video"
                                  ? _c(
                                      "div",
                                      [
                                        _c("newsfeed-shared-video", {
                                          attrs: { data: _vm.report.module },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Event"
                                  ? _c(
                                      "div",
                                      [
                                        _c("newsfeed-shared-event", {
                                          attrs: { data: _vm.report.module },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Job"
                                  ? _c(
                                      "div",
                                      [
                                        _c("newsfeed-shared-job", {
                                          attrs: { data: _vm.report.module },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Stack\\Question"
                                  ? _c("div", { staticClass: "p-1" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "font-medium-3 text-dark text-bold-700",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                   " +
                                              _vm._s(_vm.report.module.title) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.report.module.body
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Newsfeed"
                                  ? _c("div", { staticClass: "p-1" }, [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.report.module.body
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Stack\\QuestionResponse"
                                  ? _c("div", { staticClass: "p-1" }, [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.report.module.answer
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Stack\\Comment"
                                  ? _c("div", { staticClass: "p-1" }, [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.report.module.reply
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm.report.reportable_type ===
                                    "App\\Models\\Comment"
                                  ? _c("div", { staticClass: "p-1" }, [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.report.module.comment_text
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ]
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "text-center m-1 p-1 bg-outline-gray",
                                },
                                [
                                  _vm.report.module === null
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.__("newsfeed.deleted_post")
                                            ) +
                                            "\n                            "
                                        ),
                                      ])
                                    : _vm.report.module.owner === null
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.__("newsfeed.deleted_owner")
                                            ) +
                                            "\n                            "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.post_link !== "#"
                        ? _c("div", { staticClass: "text-right" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn-sm btn-flat-light text-bold-700",
                                staticStyle: { color: "inherit" },
                                attrs: { href: _vm.post_link },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.__("globals.view")) +
                                    " "
                                ),
                                _c("i", {
                                  staticClass: "feather icon-arrow-right",
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _c("div", { staticClass: "text-center" }, [
                      _c("span", {
                        staticClass:
                          "spinner-border spinner-border-md text-primary",
                      }),
                    ]),
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }